document.addEventListener("DOMContentLoaded", () => {
  const textInput = document.getElementById("note");
  const limitMessage = document.querySelector(".limitMessage");
  limitMessage.style.textAlign = 'right';
  const cartForm = document.getElementById("cart_form");
  let limited = false;
  let checked;
  const checkBox = document.querySelector(".note-toggle");
  const confirmBtn = document.querySelector(".add_to_cart");
  const continueBtn = document.querySelector(
    ".cart_content__continue-shopping"
  );
  const setWordsLimitMessage = () => {
    let charactersLeft = 225 - textInput.value.length;
    if (limited) {
      limitMessage.innerHTML = `<div class="limited-message"><img src="//reluctanttrading.com/cdn/shop/t/75/assets/alert.svg?v=156678486227805703571731609467" /><p>Sorry, gift message must be less than 225 characters.</p></div>`;
      limitMessage.style.textAlign = 'left';
    } else {
      limitMessage.textContent = `${charactersLeft}/225 characters remaining`;
      textInput.style.border = "1px solid rgb(204, 204, 204)";
      limitMessage.style.color = "rgb(38, 38, 38)";
      limitMessage.style.textAlign = 'right';
    }
  };
  if (checkBox.classList.contains("checked")) {
    checked = true
    confirmBtn.textContent = "confirm & checkout";
    continueBtn.style.display = "none";
    setWordsLimitMessage();
  } else {
    checked = false
    confirmBtn.textContent = "checkout";
    continueBtn.style.display = "flex";
    limitMessage.style.display = 'none'
  }
  
  textInput.addEventListener("input", (e) => {
    textLength = e.target.value.length;
    if (textLength >= 225) {
      limited = true;
      textInput.style.border = "2px solid red";
      limitMessage.style.color = "red";
    } else {
      limited = false;
    }
    setWordsLimitMessage();
  });


  const subtotalDiv = document.querySelector(".subtotal");
  const preview = document.createElement("div");
  preview.className = "preview-message";
  let editBtn = document.createElement("button");
  editBtn.className = "edit-btn";
  editBtn.textContent = "edit gift message";
  let finalStep = false;

  checkBox.addEventListener("click", (e) => {
    checked = !checked;
    finalStep = false;
    if (checked) {
      confirmBtn.textContent = "confirm & checkout";
      textInput.style.display = "block";
      limitMessage.style.display = "block";
      continueBtn.style.display = "none";
    } else {
      textInput.value = "";
      setWordsLimitMessage();
      confirmBtn.textContent = "checkout";
      continueBtn.style.display = "flex";
      textInput.style.display = "none";
      preview.style.display = "none";
      editBtn.style.display = "none";
      limitMessage.style.display = 'none'
    }
  });

  const submitHandler = (e) => {
    e.preventDefault();
    if (!finalStep) {
      subtotalDiv.insertBefore(editBtn, confirmBtn.nextSibling);
      preview.textContent = textInput.value;
      subtotalDiv.insertBefore(preview, confirmBtn);
      limitMessage.style.display = "none";
      textInput.style.display = "none";
      editBtn.style.display = "block";
      preview.style.display = "block";
      confirmBtn.textContent = "looks good - checkout";
      finalStep = true;
    }
  };
  const editHandler = (e) => {
    e.preventDefault();
    limitMessage.style.display = "block";
    textInput.style.display = "block";
    preview.style.display = "none";
    editBtn.style.display = "none";
    confirmBtn.textContent = "confirm & checkout";
    finalStep = false;
  };
  const confirmHandler = (e) => {
    if (finalStep || !checked || textInput.value.length === 0) {
      cartForm.removeEventListener("submit", submitHandler);
      editBtn.removeEventListener("click", editHandler);
      finalStep = false;
    } else {
      cartForm.addEventListener("submit", submitHandler);
      editBtn.removeEventListener("click", editHandler);
    }
    if (editBtn) {
      editBtn.addEventListener("click", editHandler);
    }
  };

  confirmBtn.addEventListener("click", confirmHandler);
  cartForm.addEventListener("submit", submitHandler);
});
